import fetchPost from '@/api/http.js'

import fetchPostFormData from '@/api/http.js'
import axios from 'axios'

let baseURL = process.env.NODE_ENV === 'production' ? "/" : "/api";
const instance = axios.create({
    baseURL: baseURL,
    timeout: 5 * 60 * 1000,
    headers: { 'Content-Type': 'multipart/form-data' }
});

export default {
  actions: {
    // 表格数据
    fecthTableData({ }, data) {
      return fetchPost('/saas/approvalProcess/getProcessList', data)
    },
    // 流程开关
    processSwitch({ }, data) {
      return fetchPost('/saas/approvalProcess/switchProcess', data)
    },
    getEmployeeListApi1({}, data) {
      return fetchPost('/saas/user/queryList', data)
    },
    // 编辑
    writeDataApi({}, data) {
      return fetchPost('/saas/approvalProcess/addProcess', data)
    },
    // 异常流程列表
    getTableApi({ }, data) {
      return fetchPost('/saas/approvalProcess/getExceptionProcessList', data)
    },
    // 异常流程详情
    processDetailApi({ }, data) {
      return fetchPost('/saas/approvalProcess/getExceptionProcessDetail', data)
    },
    // 提交申请
    subApplicationApi({ }, data) {
      return fetchPost('/saas/approvalProcess/submitProcess', data)
    },
    // 文件上传
    uploadspefileApi({ }, data) {
      return fetchPostFormData('/saas/approvalProcess/upload', data)
    },
  }
}